import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const VolumeQuiteIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1283 4.10039C12.2427 3.99695 12.4083 3.97128 12.5468 4.0335C12.6876 4.09572 12.7778 4.23572 12.7778 4.38894V16.0556C12.7778 16.2088 12.6876 16.3488 12.5468 16.411C12.4962 16.4336 12.4426 16.4445 12.3889 16.4445C12.2948 16.4445 12.2014 16.4103 12.1283 16.3441L8.353 12.9429L6.16666 12.9445C5.52344 12.9445 5 12.4211 5 11.7778V8.66672C5 8.0235 5.52344 7.50005 6.16666 7.50005H8.35611L12.1283 4.10039ZM14.5452 7.80767C15.1612 8.46489 15.5003 9.322 15.5003 10.2219C15.5003 11.1226 15.1612 11.9797 14.546 12.6369L13.9782 12.1049C14.4581 11.5931 14.7225 10.9242 14.7225 10.2219C14.7225 9.52033 14.4581 8.85222 13.9782 8.33967L14.5452 7.80767Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
